import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

const GenerateCSV = () => {

  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const visible =
    ['QA', 'GM'].includes(user.role) &&
    state.ncr.status.id === 4;

  return visible && (
    <Button variant='success' href={`/api/ncr/${state.ncr.id}/csv`}>
      NAV Orders Only (Generate CSV)
    </Button>
  );
}

export { GenerateCSV };
